import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c4ca192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-cancel p-3" }
const _hoisted_2 = { class: "rule-list" }
const _hoisted_3 = { class: "text-weight-500 text-red text-size-16 mt-2 mb-1 caution" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-weight-500 mt-2" }, [
  /*#__PURE__*/_createTextVNode("\n            事業所様に必ず事前に電話で連絡してください"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n            現場の方々の負担を少しでも軽くするためにご協力ください。\n          ")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "text-center mt-2"
}
const _hoisted_6 = { class: "contact-box text-left bg-white border border-outline-color round-4" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "text-pre-wrap mt-2"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "text-center my-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-1 text-size-12" }, "\n            (繋がらない場合は、時間帯を変更して電話してください)\n          ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      仕事をキャンセル\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomValidationObserver, { ref: "vObserver" }, {
        default: _withCtx(({ handleSubmit }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FeatherIcon, {
                icon: "alert-triangle",
                size: "18",
                class: "caution-icon"
              }),
              _createTextVNode("事業所担当者へ電話で連絡をせずキャンセルした場合、サービス一時利用停止となります\n          ")
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("div", {
            class: _normalizeClass(["contact-block", _ctx.contactBlockClass])
          }, [
            _hoisted_4,
            _createTextVNode(),
            (_ctx.officeInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", null, "事業所名：" + _toDisplayString(_ctx.officeInfo.name), 1),
                    _createTextVNode(),
                    _createElementVNode("p", null, "担当者：" + _toDisplayString(_ctx.officeInfo.staffName), 1),
                    _createTextVNode(),
                    _createElementVNode("p", null, [
                      _createTextVNode("\n                電話番号："),
                      _createElementVNode("a", {
                        href: 'tel:' + _ctx.officeInfo.phoneNumber,
                        class: "text-blue"
                      }, _toDisplayString(_ctx.officeInfo.phoneNumber), 9, _hoisted_7)
                    ]),
                    _createTextVNode(),
                    (_ctx.officeInfo.emergencyContact)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.officeInfo.emergencyContact), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("a", {
                      href: 'tel:' + _ctx.officeInfo.phoneNumber
                    }, [
                      _createVNode(_component_AppButton, {
                        variant: "green",
                        block: true,
                        class: "d-block mt-3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("電話をする")
                        ], undefined, true),
                        _: 1
                      })
                    ], 8, _hoisted_9)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_AppCheckbox, {
              modelValue: _ctx.isCheckedContacted,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCheckedContacted) = $event)),
              id: "contacted",
              text: "担当者に電話が繋がりキャンセルの承諾を得た",
              class: "mt-2 cancel-check-box"
            }, null, 8, ["modelValue"]),
            _createTextVNode(),
            _hoisted_11
          ]),
          _createTextVNode(),
          _createVNode(_component_AppButton, {
            disabled: !_ctx.isCheckedContacted,
            block: true,
            variant: "secondary",
            class: "d-block mt-2 py-2",
            onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmitButton))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
            ], undefined, true),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]),
        _: 1
      }, 512)
    ])
  ]))
}